import React from 'react';
import './WorkshopsPage.css';

function WorkshopsPage() {
    return (
        <div className="workshops-page">
            <div className="workshops-inner">
                <h1 className="workshops-title">Warsztaty</h1>
                <p className="workshops-desc">
                    Naucz się tworzyć własną ceramikę od podstaw.
                </p>
                <p className="coming-soon">Szczegóły wkrótce...</p>
            </div>
        </div>
    );
}

export default WorkshopsPage;
